import type { FC } from 'react';

import ServicesTypeView from 'components/UI/organisms/ServicesTypeView/ServicesTypeView';

const ServicesTypesPage: FC = () => <ServicesTypeView />;

export default ServicesTypesPage;
